module.exports = __webpack_public_path__ + "img/XR.8a97f4e8.png";